import { render, staticRenderFns } from "./WhatsappOptIn.vue?vue&type=template&id=7039620e&scoped=true&"
import script from "./WhatsappOptIn.vue?vue&type=script&lang=js&"
export * from "./WhatsappOptIn.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappOptIn.vue?vue&type=style&index=0&id=7039620e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7039620e",
  null
  
)

export default component.exports